import React from 'react';
import PropTypes from 'prop-types';
import { inlineElements, generateStyle, setOverLay, l } from '../../functions';

import { MyDraggable as Draggable } from '../../components/Core';
import HoverBar from '../../components/HoverBar';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col } from 'reactstrap';

import state from '../../state';
import Icon from '../../components/Icons';

import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';

function mapStateToProps(state) {
  return {
    settings: state.rootReducer?.appearanceSettings || {},
    currentDevice: state.rootReducer?.currentDevice || 'xl',
  };
}

class CheckoutSteps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  shouldComponentUpdate(nextProp, nextState) {
    if (!isEqual(this.props?.payload, nextProp?.payload) || !isEqual(this.props?.settings, nextProp?.settings)) {
      return true;
    }

    return false;
  }

  _initSteps = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;
    const settings = this.props.settings || {};
    let textsettings = {};

    const datasSettings = payload.datas || {};

    const stepsSettings = payload['settings-' + this.props.currentDevice] || payload.settings || {};

    const stepsCss = {
      ...datasSettings,
      ...stepsSettings,
    };

    const {
      nextStepBackgroundColor,
      previousStepBackgroundColor,
      currentStepBackgroundColor,
      nextStepTextColor,
      previousStepTextColor,
      currentStepTextColor,
    } = stepsCss || {};

    const cssSettings = generateStyle(payload, 'container');
    const cssSettingsText = generateStyle(payload, 'text', 'H4');
    // if (settings["Paragraph"]) {
    //   const setting = settings["Paragraph"];
    //   const fontFamily =
    //     settings["heading_font"] && settings["heading_font"].fontFamily;
    //   textsettings = {
    //     fontFamily: fontFamily,
    //     textSize: setting.size,
    //   };
    // }

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className='fullcol checkout-steps' style={cssSettingsText}>
            <div className='deprecated-message'>
              <h1>DEPRECATED</h1>
            </div>
            <div className='steapbar'>
              <div className='steps'>
                <ul role='tablist'>
                  <li className='first previous-step'>
                    <a
                      href='#0'
                      style={{
                        backgroundColor: previousStepBackgroundColor ? previousStepBackgroundColor : '#f042a8',
                        color: previousStepTextColor ? previousStepTextColor : '#ffffff',
                        ...textsettings,
                      }}
                    >
                      <span
                        className='before'
                        style={{
                          borderBottom: `22px solid ${
                            previousStepBackgroundColor ? previousStepBackgroundColor : '#f042a8'
                          }`,
                          borderTop: `22px solid ${
                            previousStepBackgroundColor ? previousStepBackgroundColor : '#f042a8'
                          }`,
                          ...textsettings,
                        }}
                      ></span>
                      <span className='current-info audible'>current step:</span>
                      Cart
                      <span
                        className='after'
                        style={{
                          borderLeft: `20px solid ${
                            previousStepBackgroundColor ? previousStepBackgroundColor : '#f042a8'
                          }`,
                          ...textsettings,
                        }}
                      ></span>
                    </a>
                  </li>
                  <li className='disabled current-step'>
                    <a
                      href='#0'
                      style={{
                        backgroundColor: currentStepBackgroundColor ? currentStepBackgroundColor : '#4370a4',
                        color: currentStepTextColor ? currentStepTextColor : '#ffffff',
                        ...textsettings,
                      }}
                    >
                      <span
                        className='before'
                        style={{
                          borderBottom: `22px solid ${
                            currentStepBackgroundColor ? currentStepBackgroundColor : '#4370a4'
                          }`,
                          borderTop: `22px solid ${
                            currentStepBackgroundColor ? currentStepBackgroundColor : '#4370a4'
                          }`,
                          ...textsettings,
                        }}
                      ></span>
                      Customer information
                      <span
                        className='after'
                        style={{
                          borderLeft: `20px solid ${
                            currentStepBackgroundColor ? currentStepBackgroundColor : '#4370a4'
                          }`,
                          ...textsettings,
                        }}
                      ></span>
                    </a>
                  </li>
                  <li className='disabled next-step'>
                    <a
                      href='#0'
                      style={{
                        backgroundColor: nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee',
                        color: nextStepTextColor ? nextStepTextColor : '#000000',
                        ...textsettings,
                      }}
                    >
                      <span
                        className='before'
                        style={{
                          borderBottom: `22px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          borderTop: `22px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          ...textsettings,
                        }}
                      ></span>
                      Shipping method
                      <span
                        className='after'
                        style={{
                          borderLeft: `20px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          ...textsettings,
                        }}
                      ></span>
                    </a>
                  </li>
                  <li className='disabled last next-step'>
                    <a
                      href='#0'
                      style={{
                        backgroundColor: nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee',
                        color: nextStepTextColor ? nextStepTextColor : '#000000',
                        ...textsettings,
                      }}
                    >
                      <span
                        className='before'
                        style={{
                          borderBottom: `22px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          borderTop: `22px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          ...textsettings,
                        }}
                      ></span>
                      Payment method
                      <span
                        className='after'
                        style={{
                          borderLeft: `20px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          ...textsettings,
                        }}
                      ></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const { dropzoneID, parentID, showBasicContent, showPreview, id, dropzoneProps, payload, options, ...rest } =
      this.props;

    if (showBasicContent) {
      const elements = state.getStorableState();
      let inDrop = false;

      if (Array.isArray(elements) && elements.length > 0) {
        const inlinedElements = inlineElements(elements);
        if (Array.isArray(inlinedElements) && inlinedElements.length > 0) {
          inlinedElements.forEach((element) => {
            if (element.type === this.props.type) inDrop = true;
          });
        } else inDrop = false;
      } else inDrop = false;

      return (
        <Draggable {...this.props} side={true}>
          <span className='dragger'>
            {(Array.isArray(rest.icon) && <FontAwesomeIcon icon={rest.icon} />) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
            {(inDrop && <span className='added'>{l('Added')}</span>) || (
              <span className='required'>{l('Required')}</span>
            )}
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initSteps()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initSteps()}
      </Draggable>
    );
  }
}

CheckoutSteps.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(CheckoutSteps);
